import React, { useState } from "react";
import { Wrapper } from "./ExpensesListCard.styled";
import { Button, Popconfirm } from "components/common";
import { useHistory } from "react-router";
import { getUserPermissions } from "utils/text";
const ExpensesListCard = ({
  setIsOpen,
  getExpenseData,
  deleteExpense,
  leadData,
  userData,
  expenseData,
  setEditData,
}) => {
  const history = useHistory();

  let leadName = leadData?.filter((el) => el.id == getExpenseData?.leadId)?.[0];
  return (
    <Wrapper>
      <div>
        <div className="flex">
          <h5>Invoice Date</h5>
          <h6>{getExpenseData?.invoiceDate}</h6>
        </div>
        <div className="flex">
          <h5>Description</h5>
          <h6 style={{width:"250px"}}>{getExpenseData?.description}</h6>
        </div>
        <div className="flex">
          <h5>Category Name</h5>
          <h6 style={{ textAlign: "end" }}>
            {
              expenseData?.filter(
                (el) => el.id == getExpenseData?.category
              )?.[0]?.name
            }
          </h6>
        </div>
        <div className="flex">
          <h5>Amount</h5>
          <h6>{getExpenseData?.amount}</h6>
        </div>
        <div className="flex">
          <h5>Status</h5>
          <h6>{getExpenseData?.status == true ? "Paid" : "Unpaid"}</h6>
        </div>
        <div className="flex">
          <h5>Lead</h5>
          <h6>
            {leadName?.firstName} {leadName?.lastName}
          </h6>
        </div>
        <div className="flex">
          <h5>User</h5>
          <h6>
            {
              userData?.filter(
                (el) => el.objectID == getExpenseData?.userId
              )?.[0]?.name
            }
          </h6>
        </div>
        {getUserPermissions("edit-expense-action") && (
          <Button
            title="Edit"
            className="action-buttons"
            onClick={() => {
              setIsOpen(true);
              setEditData(getExpenseData);
            }}
          />
        )}
        {getUserPermissions("delete-expense-action") && (
          <Popconfirm
            title="Are you sure want to delete"
            onConfirm={() => {
              deleteExpense(getExpenseData.id);
            }}
          >
            <Button title="Delete" className="action-buttons" />
          </Popconfirm>
        )}
        {getUserPermissions("expense-details-action") && (
          <Button
            title="Details"
            className="action-buttons"
            onClick={() => {
              history.push(`/payment-expense/${getExpenseData.id}`);
            }}
          />
        )}
      </div>
    </Wrapper>
  );
};

export default ExpensesListCard;
